<script>
    import { params } from "@roxi/routify";
    import { ServiceConsts } from "../../services/ServiceConsts";
    import { LocalStorage } from "../../services/LocalStorage";
    import { CacheService } from "../../services/CacheService";


    if ($params.redirectUrl) {
        let redirectUrl = $params.redirectUrl;

        // if it's @[pdfLink].svelte then encode the path
        if (
            $params.redirectUrl.startsWith("/pdf") &&
            $params.redirectUrl.length > 5
        ) {
            // remove the /pdf/ part
            let path = redirectUrl.substring(5);

            // remove last slash if it exists
            if (path.endsWith("/")) {
                path = path.substring(0, path.length - 1);
            }

            // create the redirect url
            redirectUrl = "/pdf/" + encodeURIComponent(path) + "/";
        }

        LocalStorage.set("IN_APP_REDIRECT", redirectUrl);
    }

    // NOTE: All cache is cleared on login and logout. While Logout is obvious
    //       we need to clear it on login as well to handle situations where
    //       the token has expired and user is logged out that way
    CacheService.clearAll().then(() => {
        console.log("All cache cleared successfully.");
    }).catch((error) => {
        console.warn("Error clearing cache:", error);
    });

    window.location.replace(
        ServiceConsts.LOGIN_URL +
            "?redirectUrl=" +
            window.location.origin +
            "/auth",
    );
</script>

Redirecting to auth server...
